import React, {useContext} from 'react'
import * as Yup from 'yup'
import { Formik, Field, Form } from 'formik';
import {useListView} from '@/components/table/core/ListViewProvider'
import {useQueryResponse} from '@/components/table/core/QueryResponseProvider'
import {CustomerContext} from '../../CustomerContext'
import {addExceptionalCredits} from '../../../../statement/core/_requests'
import {InputText, TextArea, FormActions, handleErrors } from '@/components/form'

interface FormValues {
  credits: number;
  remark: string;
}

const schema = Yup.object({
  credits: Yup.number().integer().typeError('limit must be a number').positive().required(),
  remark: Yup.string().required(),
})


const MissingCreditForm = () => {
  // TODO yup
  const { customer, refresh: refreshUser } = useContext(CustomerContext)
  const {setItemForUpdate, setAction} = useListView()
  const {refetch} = useQueryResponse()
  const close = () => {
    setItemForUpdate(undefined)
    setAction(undefined)
  }

  if (!customer) {
    return (<></>)
  }
  const initialValues: FormValues = {
    credits: 0,
    remark: ''
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={async (values, {setErrors}) => {
        try {
          await addExceptionalCredits(customer._id, values.credits, values.remark)
          await refreshUser()
          refetch()
          close()
        } catch (e: unknown) {
          handleErrors(e, setErrors)
        }
      }}
    >
      {() => {
        return (
          <Form> 
            <Field
              name="credits"
              label="Credits"
              component={InputText}
              className="form-control"
              type="number"
              placeholder="0"
              required={true}
            />

            <Field
              name="remark"
              label="Remark"
              component={TextArea}
              className="form-control"
              placeholder="Put reason of exceptional credits"
              required={true}
            />

            <Field
              component={FormActions}
              position='end'
              close={close}
            />
          </Form>
        )
      }}
    </Formik>
  )
}

export default MissingCreditForm;
